import { MediaMatcher } from '@angular/cdk/layout';
import { HttpClient } from '@angular/common/http';
import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { FormArray, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { RxwebValidators } from '@rxweb/reactive-form-validators';
import { ViewReasonComponent } from 'src/app/admin/components/view-reason/view-reason.component';
import { AppComponent } from 'src/app/app.component';
import { ApiService } from 'src/app/services/api.service';
import { NotifyService } from 'src/app/services/notify.service';
import { ValueService } from 'src/app/services/value.service';
import { environment } from 'src/environments/environment';
declare let $: any;

@Component({
  selector: 'app-hr-page',
  templateUrl: './hr-page.component.html',
  styleUrls: ['./hr-page.component.css'],
})
export class HrPageComponent implements OnInit {
  settingsForm: FormGroup;
  private saveApi = environment.url + environment.hrSave;
  private getApi = environment.url + environment.hrGet;
  /**
   * This is the constructor for the HrPageComponent class.
   * It injects the dependencies required by the component.
   * It also initializes the settingsForm with the form controls for each question.
   * @param changeDetectorRef The ChangeDetectorRef is used to detect changes in the component.
   * @param media The MediaQueryList is used to detect the screen size.
   * @param fb The FormBuilder is used to create the form controls.
   * @param makeapi The ApiService is used to make API calls.
   * @param getdata The ValueService is used to get the values from the API.
   * @param notify The NotifyService is used to show notifications.
   * @param dialog The MatDialog is used to show the dialog for viewing the reasons.
   * @param appCom The AppComponent is used to access the app component.
   * @param http The HttpClient is used to make HTTP requests.
   */
  constructor(
    changeDetectorRef: ChangeDetectorRef,
    media: MediaMatcher,
    private fb: FormBuilder,
    private makeapi: ApiService,
    private getdata: ValueService,
    private notify: NotifyService,
    public dialog: MatDialog,
    private appCom: AppComponent,
    private http: HttpClient
  ) {
    /**
     * This is the form group for the page.
     * It contains the form controls for each question.
     */
    this.settingsForm = this.fb.group({
      // question 002
      overallExperienceIncCentre: [''],
      overallExperienceDocuments: new FormArray([]),
      overallExperienceImagefile: [''],
      overallExperienceTotalYearOfExperience: [''],
      overallExperienceStatus: [''],
      // question 003
      capacityDevelopmentProgramIncCentre: [''],
      capacityDevelopmentProgramDocuments: new FormArray([]),
      capacityDevelopmentProgramNoOfTraining: [''],
      capacityDevelopmentProgramImagefile: [''],
      capacityDevelopmentProgramStatus: [''],
      // question 004
      humanResourcesIncCentre: [''],
      humanResourcesDocuments: new FormArray([]),
      humanResourcesImagefile: [''],
      humanResourcesStatus: [''],
      // question 005
      workspaceLabsInfraIncCentre: [''],
      workspaceLabsInfraDocuments: new FormArray([]),
      workspaceLabsInfraImagefile: [''],
      workspaceLabsInfraNoOfSOP: [''],
      workspaceLabsInfraStatus: [''],
      // question 006
      trainedSkilledManpowerIncCentre: [''],
      trainedSkilledManpowerDocuments: new FormArray([]),
      trainedSkilledManpowerImagefile: [''],
      trainedSkilledManpowerNoOfManpower: [''],
      trainedSkilledManpowerStatus: [''],
      // question 007
      consultantsOrInternsIncCentre: [''],
      consultantsOrInternsDocuments: new FormArray([]),
      consultantsOrInternsImagefile: [''],
      consultantsOrInternsNoOfConsultants: [''],
      consultantsOrInternsStatus: [''],
      // question 008
      grievencesRedressalIncCentre: [''],
      grievencesRedressalDocuments: new FormArray([]),
      grievencesRedressalImagefile: [''],
      grievencesRedressalStatus: [''],
      grievencesRedressalUrlIcWebsite: [''],
      // question 009
      exitInterviewPolicyIncCentre: [''],
      exitInterviewPolicyDocuments: new FormArray([]),
      exitInterviewPolicyImagefile: [''],
      exitInterviewPolicyStatus: [''],
      // new 1st question
      availabilityIncTeamIncCentre: [''],
      availabilityIncTeamUrlIcWebsite: [''],
      availabilityIncTeamdocuments: new FormArray([]),
      availabilityIncTeamImagefile: [''],
      availabilityIncTeamStatus: [],
    });
    this.mobileQuery = media.matchMedia('(max-width: 992px)');
    this._mobileQueryListener = () => changeDetectorRef.detectChanges();
  }
  mobileQuery: MediaQueryList;
  private _mobileQueryListener: () => void;
  ngAfterViewInit(): void {
    this.mobileQuery.removeListener(this._mobileQueryListener);
  }
  get setting() {
    return this.settingsForm.controls;
  }
  /**
   * This method is called when the component is initialized.
   * It calls the {@link getPush} method to get the push notification permission,
   * the {@link getDataApi} method to get the data from the API,
   * and the {@link guidelineDatas} method to get the guideline data from the API.
   */
  ngOnInit(): void {
    // Get push notification permission
    this.getPush();

    // Get data from API
    this.getDataApi();

    // Get guideline data from API
    this.guidelineDatas();
  }
  getValue: any = {};
  /**
   * Fetches HR-related data from the API and updates the form and UI accordingly.
   *
   * - Displays a loading indicator during the API request.
   * - Retrieves user-specific HR data using the stored user ID.
   * - If the response is successful, patches the form with the received data.
   * - Shows/hides UI options based on specific data attributes.
   * - Loads and displays associated documents, updating the UI to reflect successful uploads.
   * - Handles UI updates using jQuery to show/hide upload and remove wrappers with success indicators.
   * - Hides the loading indicator after processing is complete.
   */
  getDataApi() {
    // Show loading indicator
    this.getdata.amizhthLoader('show');

    // Make API call to fetch data
    this.makeapi
      .method(this.getApi + sessionStorage.getItem('userId'), '', 'get')
      .subscribe((data) => {
        // Hide loading indicator after receiving data
        this.getdata.amizhthLoader('hide');
        this.getValue = data;

        // Check if the API response is successful
        if (data.responseStatus != 'Failed') {
          // Update settings form with received data
          this.settingsForm.patchValue(data);

          // Handle options based on data attributes
          if (data.teamStructureIncCentre == 'Yes') {
            this.showOptionsone('Yes', '.upload0', 0, '.set-succ0');
          }
          if (data.overallExperienceIncCentre == 'Yes') {
            this.showOptionstwo('Yes', '.upload1', 1, '.set-succ1');
          }
          if (data.capacityDevelopmentProgramIncCentre == 'Yes') {
            this.showOptionsthree('Yes', '.upload2', 2, '.set-succ2');
          }
          if (data.humanResourcesIncCentre == 'Yes') {
            this.showOptionsfour('Yes', '.upload3', 3, '.set-succ3');
          }
          if (data.workspaceLabsInfraIncCentre == 'Yes') {
            this.showOptionsfive('Yes', '.upload4', 4, '.set-succ4');
          }
          if (data.trainedSkilledManpowerIncCentre == 'Yes') {
            this.showOptionssix('Yes', '.upload5', 5, '.set-succ5');
          }
          if (data.consultantsOrInternsIncCentre == 'Yes') {
            this.showOptionsseven('Yes', '.upload6', 6, '.set-succ6');
          }
          if (data.grievencesRedressalIncCentre == 'Yes') {
            this.showOptions8('Yes', '.upload7', 7, '.set-succ7');
          }
          if (data.exitInterviewPolicyIncCentre == 'Yes') {
            this.showOptions9('Yes', '.upload8', 8, '.set-succ8');
          }
          if (data.availabilityIncTeamIncCentre == 'Yes') {
            this.showOptions10('Yes', '.upload9', 9, '.set-succ9');
          }

          let getform = this.settingsForm.value;

          // Handle document uploads and UI updates
          const documentMappings = [
            { key: 'teamStructure', index: 0 },
            { key: 'overallExperience', index: 1 },
            { key: 'capacityDevelopmentProgram', index: 2 },
            { key: 'humanResources', index: 3 },
            { key: 'workspaceLabsInfra', index: 4 },
            { key: 'trainedSkilledManpower', index: 5 },
            { key: 'consultantsOrInterns', index: 6 },
            { key: 'grievencesRedressal', index: 7 },
            { key: 'exitInterviewPolicy', index: 8 },
            { key: 'availabilityIncTeam', index: 9 },
          ];

          documentMappings.forEach(({ key, index }) => {
            const documentKey = `${key}Documents`;
            const imageFileKey = `${key}Imagefile`;

            if (data[documentKey] && data[documentKey] !== '') {
              this.documentValues[index] = data[documentKey];
              getform[imageFileKey] = data[documentKey][0]?.documentFile;

              setTimeout(() => {
                $(`.set-succ${index}`).addClass('success');
                $(`.upload-wrapper.upload${index}`)
                  .addClass('d-none')
                  .removeClass('success');
                $(`.remove-wrapper.upload${index}`).addClass('d-flex active');
              }, 5000);
            }
          });

          // Patch the form with updated values
          this.settingsForm.patchValue(getform);
        }
      });
  }

  pickColor(val) {
    return this.getdata.questionStatus(val);
  }
  pickWidth(val) {
    return this.getdata.statusWidth(val);
  }
  innerValue(val) {
    return this.getdata.StatusName(val);
  }
  /**
   * Opens a dialog to display the reason for the given status.
   * @param status - The status object or value to show the reason for.
   */
  viewReasonBtn(status) {
    // Open the dialog with the ViewReasonComponent
    const dialogRef = this.dialog.open(ViewReasonComponent, {
      width: '390px',
      data: { _status: status },
    });

    // Subscribe to the afterClosed event of the dialog
    dialogRef.afterClosed().subscribe((result) => {
      // No action needed after the dialog is closed
    });
  }
  /**
   * Sets the value of the specified form control in the settings form.
   *
   * @param event - The event that triggered this function (not used).
   * @param key - The name of the form control to update.
   * @param value - The value to set the form control to.
   */
  setStatus(event, key: string, value: any) {
    this.settingsForm.controls[key].setValue(value);
  }

  /**
   * Populates the `documentValues` array with 10 new document request objects,
   * each containing empty `documentName` and `documentFile` fields.
   */
  getPush() {
    // Loop 10 times to create 10 new document request objects
    for (let i = 0; i < 10; i++) {
      // Create a new document request object with empty fields
      const req = [
        {
          documentName: '',
          documentFile: '',
        },
      ];
      // Add the object to the documentValues array
      this.documentValues.push(req);
    }
  }

  selecetdFile: any = [];
  url: any;
  ImageValue: any = '';
  ImageType: any;
  documentValues = [];
  /**
   * Handles the file upload event.
   *
   * @param event - The file upload event.
   * @param val - Identifier value to locate the file and UI elements.
   * @param i - Index for identifying which file and form control to modify.
   * @param set - UI element class to update its state.
   */
  fileUpload(event, val, i, set) {
    this.selecetdFile = event.target.files[0];
    if (event.target.files && this.selecetdFile) {
      let reader = new FileReader();
      let imagetype = this.selecetdFile.type;
      let imagedatatype = imagetype.split('/');
      let img_crt_type = imagedatatype[1];

      // Check if the uploaded file is of the allowed type
      if (
        img_crt_type == 'jpeg' ||
        img_crt_type == 'jpg' ||
        img_crt_type == 'png' ||
        img_crt_type == 'pdf'
      ) {
        reader.readAsDataURL(this.selecetdFile);
        reader.onload = () => {
          this.url = reader.result;
          let spl = this.url.split(',');
          let val = this.documentValues[i];
          val[0].documentFile = spl[1];
          val[0].documentName = this.selecetdFile.name;
          this.documentValues[i] = val;
          // Update the form control values based on the index
          switch (i) {
            case 0:
              this.settingsForm.controls['teamStructureStatus'].setValue(7);
              this.settingsForm.controls['teamStructureImagefile'].setValue(
                this.selecetdFile.name
              );
              break;
            case 1:
              this.settingsForm.controls['overallExperienceStatus'].setValue(7);
              this.settingsForm.controls['overallExperienceImagefile'].setValue(
                this.selecetdFile.name
              );
              break;
            case 2:
              this.settingsForm.controls[
                'capacityDevelopmentProgramStatus'
              ].setValue(7);
              this.settingsForm.controls[
                'capacityDevelopmentProgramImagefile'
              ].setValue(this.selecetdFile.name);
              break;
            case 3:
              this.settingsForm.controls['humanResourcesStatus'].setValue(7);
              this.settingsForm.controls['humanResourcesImagefile'].setValue(
                this.selecetdFile.name
              );
              break;
            case 4:
              this.settingsForm.controls['workspaceLabsInfraStatus'].setValue(
                7
              );
              this.settingsForm.controls[
                'workspaceLabsInfraImagefile'
              ].setValue(this.selecetdFile.name);
              break;
            case 5:
              this.settingsForm.controls[
                'trainedSkilledManpowerStatus'
              ].setValue(7);
              this.settingsForm.controls[
                'trainedSkilledManpowerImagefile'
              ].setValue(this.selecetdFile.name);
              break;
            case 6:
              this.settingsForm.controls['consultantsOrInternsStatus'].setValue(
                7
              );
              this.settingsForm.controls[
                'consultantsOrInternsImagefile'
              ].setValue(this.selecetdFile.name);
              break;
            case 7:
              this.settingsForm.controls['grievencesRedressalStatus'].setValue(
                7
              );
              this.settingsForm.controls[
                'grievencesRedressalImagefile'
              ].setValue(this.selecetdFile.name);
              break;
            case 8:
              this.settingsForm.controls['exitInterviewPolicyStatus'].setValue(
                7
              );
              this.settingsForm.controls[
                'exitInterviewPolicyImagefile'
              ].setValue(this.selecetdFile.name);
              break;
            // new 1st queston
            case 9:
              this.settingsForm.controls['availabilityIncTeamStatus'].setValue(
                7
              );
              this.settingsForm.controls[
                'availabilityIncTeamImagefile'
              ].setValue(this.selecetdFile.name);
              break;
          }
        };
        // Update the UI state after a delay
        setTimeout(function () {
          let datass = '.upload-wrapper' + val;
          $(datass).addClass('uploaded');
        }, 600);
        setTimeout(function () {
          let datas = '.upload-wrapper' + val;
          $(datas).removeClass('uploaded');
          $(datas).addClass('success');
          $(set).addClass('success');
        }, 1600);
        setTimeout(function () {
          let datas = '.upload-wrapper' + val;
          $(datas).addClass('d-none');
          $(datas).removeClass('success');
          let data = '.remove-wrapper' + val;
          $(data).addClass('d-flex');
          $(data).addClass('active');
        }, 5000);
      } else {
        this.notify.notifyError(
          'Only *jpeg,*jpg,*png formet images are allowed'
        );
      }
    }
  }
  /**
   * Removes the file associated with the given index and updates the UI.
   *
   * @param val - Identifier value to locate the file and UI elements.
   * @param i - Index for identifying which file and form control to modify.
   * @param set - UI element class to update its state.
   */
  removeFile(val, i, set) {
    // Clear the document file and name for the given index
    this.documentValues[i][0].documentFile = '';
    this.documentValues[i][0].documentName = '';

    // Update the UI state after a delay
    setTimeout(() => {
      let datass = '.upload-wrapper' + val;
      $(datass).removeClass('d-none');
      let data = '.remove-wrapper' + val;
      $(data).removeClass('d-flex');
      $(data).removeClass('active');
      $(set).removeClass('success');
    }, 1000);

    // Clear the form control values based on the index
    switch (i) {
      case 0:
        this.settingsForm.controls['teamStructureImagefile'].setValue('');
        break;
      case 1:
        this.settingsForm.controls['overallExperienceImagefile'].setValue('');
        break;
      case 2:
        this.settingsForm.controls[
          'capacityDevelopmentProgramImagefile'
        ].setValue('');
        break;
      case 3:
        this.settingsForm.controls['humanResourcesImagefile'].setValue('');
        break;
      case 4:
        this.settingsForm.controls['workspaceLabsInfraImagefile'].setValue('');
        break;
      case 5:
        this.settingsForm.controls['trainedSkilledManpowerImagefile'].setValue(
          ''
        );
        break;
      case 6:
        this.settingsForm.controls['consultantsOrInternsImagefile'].setValue(
          ''
        );
        break;
      case 7:
        this.settingsForm.controls['grievencesRedressalImagefile'].setValue('');
        break;
      case 8:
        this.settingsForm.controls['exitInterviewPolicyImagefile'].setValue('');
        break;
      case 9:
        this.settingsForm.controls['availabilityIncTeamImagefile'].setValue('');
        break;
      default:
        break;
    }
  }
  Optionsonechecked = '';
  /**
   * Handles the change event for the "Team Structure" option.
   * Updates form controls based on the selected option.
   *
   * @param event - The selected value of the radio button ('Yes' or 'No').
   * @param val - Additional value used for the operation.
   * @param i - Index for control identification.
   * @param set - Additional set information for operation.
   */
  showOptionsone(event, val, i, set) {
    // Store the selected option in Optionsonechecked
    this.Optionsonechecked = event;

    if (event == 'No') {
      // If 'No' is selected, remove the file and clear validators
      this.removeFile(val, i, set);
      // Reset the status and clear URL and image file values and validators
      this.settingsForm.controls['teamStructureStatus'].setValue(1);
      this.settingsForm.controls['teamStructureUrlIcWebsite'].setValue('');
      this.settingsForm.controls['teamStructureImagefile'].setValue('');
      this.settingsForm.controls['teamStructureUrlIcWebsite'].clearValidators();
      this.settingsForm.controls['teamStructureImagefile'].clearValidators();
    } else {
      // If 'Yes' is selected, set required validators for URL and image file controls
      this.settingsForm.controls['teamStructureUrlIcWebsite'].setValidators([
        Validators.required,
        RxwebValidators.url(),
      ]);
      this.settingsForm.controls['teamStructureImagefile'].setValidators([
        Validators.required,
      ]);
    }

    // Update the validity of the form controls
    this.settingsForm.controls[
      'teamStructureUrlIcWebsite'
    ].updateValueAndValidity();
    this.settingsForm.controls[
      'teamStructureImagefile'
    ].updateValueAndValidity();
  }
  Optionstwochecked = '';
  /**
   * Handles the change event for the "Overall Experience" option.
   * Updates form controls based on the selected option.
   *
   * @param event - The selected value of the radio button ('Yes' or 'No').
   * @param val - Additional value used for the operation.
   * @param i - Index for control identification.
   * @param set - Additional set information for operation.
   */
  showOptionstwo(event, val, i, set) {
    // Store the selected option in Optionstwochecked
    this.Optionstwochecked = event;

    if (event == 'No') {
      // If 'No' is selected, remove the file and clear validators
      this.removeFile(val, i, set);
      this.settingsForm.controls['overallExperienceStatus'].setValue(1);
      this.settingsForm.controls[
        'overallExperienceTotalYearOfExperience'
      ].setValue(null);
      this.settingsForm.controls[
        'overallExperienceTotalYearOfExperience'
      ].clearValidators();
      this.settingsForm.controls['overallExperienceImagefile'].setValue('');
      this.settingsForm.controls[
        'overallExperienceImagefile'
      ].clearValidators();
    } else {
      // If 'Yes' is selected, set required validators for experience controls
      this.settingsForm.controls[
        'overallExperienceTotalYearOfExperience'
      ].setValidators([Validators.required]);
      this.settingsForm.controls['overallExperienceImagefile'].setValidators([
        Validators.required,
      ]);
    }

    // Update the validity of the form controls
    this.settingsForm.controls[
      'overallExperienceTotalYearOfExperience'
    ].updateValueAndValidity();
    this.settingsForm.controls[
      'overallExperienceImagefile'
    ].updateValueAndValidity();
  }
  Optionsthreechecked = '';
  /**
   * Handles the change event for the "Capacity Development Program" question.
   * Updates the form controls and their validators based on the selected option.
   *
   * @param event - The selected value of the radio button ('Yes' or 'No').
   * @param val - A value used for identifying the file input or related UI element.
   * @param i - The index used for updating the document values.
   * @param set - A selector or reference for additional UI updates.
   */
  showOptionsthree(event, val, i, set) {
    this.Optionsthreechecked = event;
    if (event == 'No') {
      // If 'No' is selected, remove the associated file and clear validators
      this.removeFile(val, i, set);
      this.settingsForm.controls['capacityDevelopmentProgramStatus'].setValue(
        1
      );
      this.settingsForm.controls[
        'capacityDevelopmentProgramNoOfTraining'
      ].setValue(null);
      this.settingsForm.controls[
        'capacityDevelopmentProgramNoOfTraining'
      ].clearValidators();
      this.settingsForm.controls[
        'capacityDevelopmentProgramImagefile'
      ].setValue('');
      this.settingsForm.controls[
        'capacityDevelopmentProgramImagefile'
      ].clearValidators();
    } else {
      // If 'Yes' is selected, set required validators
      this.settingsForm.controls[
        'capacityDevelopmentProgramNoOfTraining'
      ].setValidators([Validators.required]);
      this.settingsForm.controls[
        'capacityDevelopmentProgramImagefile'
      ].setValidators([Validators.required]);
    }
    // Update the validity of the form controls
    this.settingsForm.controls[
      'capacityDevelopmentProgramNoOfTraining'
    ].updateValueAndValidity();
    this.settingsForm.controls[
      'capacityDevelopmentProgramImagefile'
    ].updateValueAndValidity();
  }
  Optionsfourchecked = '';
  /**
   * Handles the change event for the "Has the institution provided resources for start-ups" question.
   * Updates the form controls and their validators based on the selected option.
   *
   * @param event - The selected value of the radio button ('Yes' or 'No').
   * @param val - A value used for identifying the file input or related UI element.
   * @param i - The index used for updating the document values.
   * @param set - A selector or reference for additional UI updates.
   */
  showOptionsfour(event, val, i, set) {
    this.Optionsfourchecked = event;
    if (event == 'No') {
      // If 'No' is selected, remove the associated file and clear validators
      this.removeFile(val, i, set);
      this.settingsForm.controls['humanResourcesStatus'].setValue(1);
      this.settingsForm.controls['humanResourcesImagefile'].setValue('');
      this.settingsForm.controls['humanResourcesImagefile'].clearValidators();
    } else {
      // If 'Yes' is selected, set validators for required fields
      this.settingsForm.controls['humanResourcesImagefile'].setValidators([
        Validators.required,
      ]);
    }
    // Update the validity of the form controls
    this.settingsForm.controls[
      'humanResourcesImagefile'
    ].updateValueAndValidity();
  }
  Optionsfivechecked = '';
  /**
   * Handles the change event for the "Has the institution provided incubation space or workspace for start-ups" question.
   * Updates the form controls and their validators based on the selected option.
   *
   * @param event - The selected value of the radio button ('Yes' or 'No').
   * @param val - A value used for identifying the file input or related UI element.
   * @param i - The index used for updating the document values.
   * @param set - A selector or reference to the form control element.
   */
  showOptionsfive(event, val, i, set) {
    this.Optionsfivechecked = event;

    // If 'No' is selected, remove the file and clear validators.
    if (event == 'No') {
      this.removeFile(val, i, set);
      this.settingsForm.controls['workspaceLabsInfraStatus'].setValue(1);
      this.settingsForm.controls['workspaceLabsInfraNoOfSOP'].setValue(null);
      this.settingsForm.controls['workspaceLabsInfraNoOfSOP'].clearValidators();
      this.settingsForm.controls['workspaceLabsInfraImagefile'].setValue('');
      this.settingsForm.controls[
        'workspaceLabsInfraImagefile'
      ].clearValidators();
    } else {
      // If 'Yes' is selected, set required validators.
      this.settingsForm.controls['workspaceLabsInfraNoOfSOP'].setValidators([
        Validators.required,
      ]);
      this.settingsForm.controls['workspaceLabsInfraImagefile'].setValidators([
        Validators.required,
      ]);
    }
    // Update the validity of the form controls.
    this.settingsForm.controls[
      'workspaceLabsInfraNoOfSOP'
    ].updateValueAndValidity();
    this.settingsForm.controls[
      'workspaceLabsInfraImagefile'
    ].updateValueAndValidity();
  }
  Optionssixchecked = '';
  /**
   * Handles the change event for the "Has the institution provided trained/skilled manpower for start-ups" question.
   * Updates the form controls and their validators based on the selected option.
   *
   * @param event - The selected value of the radio button ('Yes' or 'No').
   * @param val - A value used for identifying the file input or related UI element.
   * @param i - The index used for updating the document values.
   * @param set - A selector or reference used for additional UI updates.
   */
  showOptionssix(event, val, i, set) {
    this.Optionssixchecked = event;
    // If 'No' is selected, remove the associated file and clear validators
    if (event == 'No') {
      this.removeFile(val, i, set);
      // Clear the trainedSkilledManpowerNoOfManpower and image file values and validators
      this.settingsForm.controls['trainedSkilledManpowerStatus'].setValue(1);
      this.settingsForm.controls['trainedSkilledManpowerNoOfManpower'].setValue(
        null
      );
      this.settingsForm.controls[
        'trainedSkilledManpowerNoOfManpower'
      ].clearValidators();
      this.settingsForm.controls['trainedSkilledManpowerImagefile'].setValue(
        ''
      );
      this.settingsForm.controls[
        'trainedSkilledManpowerImagefile'
      ].clearValidators();
    } else {
      // If 'Yes' is selected, set required validators for the trainedSkilledManpowerNoOfManpower and image file controls
      this.settingsForm.controls[
        'trainedSkilledManpowerNoOfManpower'
      ].setValidators([Validators.required]);
      this.settingsForm.controls[
        'trainedSkilledManpowerImagefile'
      ].setValidators([Validators.required]);
    }
    // Update the validity of the trainedSkilledManpowerNoOfManpower and image file controls
    this.settingsForm.controls[
      'trainedSkilledManpowerNoOfManpower'
    ].updateValueAndValidity();
    this.settingsForm.controls[
      'trainedSkilledManpowerImagefile'
    ].updateValueAndValidity();
  }
  Optionssevenchecked = '';
  /**
   * Handles the change event of the "Has the institution engaged consultants/interns operating in the Incubation Centre" question.
   * Updates the form controls and their validators based on the selected option.
   *
   * @param event - The selected value of the radio button ('Yes' or 'No').
   * @param val - A value used for identifying the file input or related UI element.
   * @param i - The index used for updating the document values.
   * @param set - A selector or reference used for additional UI updates.
   */
  showOptionsseven(event, val, i, set) {
    this.Optionssevenchecked = event;
    if (event == 'No') {
      // If the user selects "No", remove the file and clear the validators.
      this.removeFile(val, i, set);
      this.settingsForm.controls['consultantsOrInternsStatus'].setValue(1);
      this.settingsForm.controls[
        'consultantsOrInternsNoOfConsultants'
      ].setValue(null);
      this.settingsForm.controls[
        'consultantsOrInternsNoOfConsultants'
      ].clearValidators();
      this.settingsForm.controls['consultantsOrInternsImagefile'].setValue('');
      this.settingsForm.controls[
        'consultantsOrInternsImagefile'
      ].clearValidators();
    } else {
      // If the user selects "Yes", set the validators for the number of consultants/interns and the image file.
      this.settingsForm.controls[
        'consultantsOrInternsNoOfConsultants'
      ].setValidators([Validators.required]);
      this.settingsForm.controls['consultantsOrInternsImagefile'].setValidators(
        [Validators.required]
      );
    }
    // Update the validity of the controls.
    this.settingsForm.controls[
      'consultantsOrInternsNoOfConsultants'
    ].updateValueAndValidity();
    this.settingsForm.controls[
      'consultantsOrInternsImagefile'
    ].updateValueAndValidity();
  }
  Options8checked = '';
  /**
   * Handles the change event for the availability of grievance redressal policy options.
   * Updates the form controls and their validators based on the selected option.
   *
   * @param event - The selected value of the radio button ('Yes' or 'No').
   * @param val - A value used for identifying the file input or related UI element.
   * @param i - The index used for updating the document values.
   * @param set - A selector or reference used for additional UI updates.
   */
  showOptions8(event, val, i, set) {
    this.Options8checked = event;

    // If the user selects 'No', remove the associated image file, clear validators and set the status to 1
    if (event == 'No') {
      this.removeFile(val, i, set);
      this.settingsForm.controls['grievencesRedressalStatus'].setValue(1);
      this.settingsForm.controls['grievencesRedressalImagefile'].setValue('');
      this.settingsForm.controls[
        'grievencesRedressalImagefile'
      ].clearValidators();
      // Clear the URL field when the user selects 'No'
      this.settingsForm.controls['grievencesRedressalUrlIcWebsite'].setValue(
        ''
      );
      this.settingsForm.controls[
        'grievencesRedressalUrlIcWebsite'
      ].clearValidators();
    }
    // If the user selects 'Yes', set the required validator for the image file
    else {
      this.settingsForm.controls[
        'grievencesRedressalUrlIcWebsite'
      ].setValidators([Validators.required]);
      this.settingsForm.controls['grievencesRedressalImagefile'].setValidators([
        Validators.required,
      ]);
    }
    // Update the validity of the grievencesRedressalImagefile control
    this.settingsForm.controls[
      'grievencesRedressalImagefile'
    ].updateValueAndValidity();
    // Update the validity of the grievencesRedressalUrlIcWebsite control
    this.settingsForm.controls[
      'grievencesRedressalUrlIcWebsite'
    ].updateValueAndValidity();
  }
  Options9checked = '';
  /**
   * Handles the change event for the availability of exit interview policy options.
   * Updates the form controls and their validators based on the selected option.
   *
   * @param event - The selected value of the radio button ('Yes' or 'No').
   * @param val - A value used for identifying the file input or related UI element.
   * @param i - The index used for updating the document values.
   * @param set - A selector or reference used for additional UI updates.
   */
  showOptions9(event, val, i, set) {
    this.Options9checked = event;

    // If the user selects 'No', remove the associated image file and clear validators
    if (event == 'No') {
      this.removeFile(val, i, set);
      this.settingsForm.controls['exitInterviewPolicyStatus'].setValue(1);
      this.settingsForm.controls['exitInterviewPolicyImagefile'].setValue('');
      this.settingsForm.controls[
        'exitInterviewPolicyImagefile'
      ].clearValidators();
    }
    // If the user selects 'Yes', set the required validator for the image file
    else {
      this.settingsForm.controls['exitInterviewPolicyImagefile'].setValidators([
        Validators.required,
      ]);
    }
    // Update the validity of the exitInterviewPolicyImagefile control
    this.settingsForm.controls[
      'exitInterviewPolicyImagefile'
    ].updateValueAndValidity();
  }
  // new 1st question
  Options10checked = '';
  /**
   * Handles the change event for the availability of incubation team options.
   * Updates the form controls and their validators based on the selected option.
   *
   * @param event - The selected value of the radio button ('Yes' or 'No').
   * @param val - A value used for identifying the file input or related UI element.
   * @param i - The index used for updating the document values.
   * @param set - A selector or reference used for additional UI updates.
   */
  showOptions10(event, val, i, set) {
    this.Options10checked = event;
    if (event == 'No') {
      // If 'No' is selected, remove the file and clear validators.
      this.removeFile(val, i, set);
      // Clear the availability of incubation team status value and validators.
      this.settingsForm.controls['availabilityIncTeamStatus'].setValue(1);
      this.settingsForm.controls['availabilityIncTeamImagefile'].setValue('');
      this.settingsForm.controls[
        'availabilityIncTeamImagefile'
      ].clearValidators();
      // Clear the availability of incubation team URL value and validators.
      this.settingsForm.controls['availabilityIncTeamUrlIcWebsite'].setValue(
        ''
      );
      this.settingsForm.controls[
        'availabilityIncTeamUrlIcWebsite'
      ].clearValidators();
    } else {
      // If 'Yes' is selected, set required validators.
      this.settingsForm.controls[
        'availabilityIncTeamUrlIcWebsite'
      ].setValidators([Validators.required]);
      this.settingsForm.controls['availabilityIncTeamImagefile'].setValidators([
        Validators.required,
      ]);
    }
    // Update the validity of the form controls.
    this.settingsForm.controls[
      'availabilityIncTeamImagefile'
    ].updateValueAndValidity();
    this.settingsForm.controls[
      'availabilityIncTeamUrlIcWebsite'
    ].updateValueAndValidity();
  }
  /**
   * This function is used to save the form data. It checks if the form is valid
   * and if yes, it sends the data to the server and saves it.
   * If the form is invalid, it shows an error message.
   */
  saveBtn() {
    let getform = this.settingsForm.value;

    // Check if the form is valid
    if (this.settingsForm.invalid) {
      // If the form is invalid, mark all the fields as touched and show an error message
      this.settingsForm.markAllAsTouched();
      this.notify.notifyError('Please fill all the mandatory fields !!');
    } else {
      // If the form is valid, get the document values
      if (this.documentValues[0][0].documentFile != '') {
        getform.teamStructureDocuments = this.documentValues[0];
      }
      if (this.documentValues[1][0].documentFile != '') {
        getform.overallExperienceDocuments = this.documentValues[1];
      }
      if (this.documentValues[2][0].documentFile != '') {
        getform.capacityDevelopmentProgramDocuments = this.documentValues[2];
      }
      if (this.documentValues[3][0].documentFile != '') {
        getform.humanResourcesDocuments = this.documentValues[3];
      }
      if (this.documentValues[4][0].documentFile != '') {
        getform.workspaceLabsInfraDocuments = this.documentValues[4];
      }
      if (this.documentValues[5][0].documentFile != '') {
        getform.trainedSkilledManpowerDocuments = this.documentValues[5];
      }
      if (this.documentValues[6][0].documentFile != '') {
        getform.consultantsOrInternsDocuments = this.documentValues[6];
      }
      if (this.documentValues[7][0].documentFile != '') {
        getform.grievencesRedressalDocuments = this.documentValues[7];
      }
      if (this.documentValues[8][0].documentFile != '') {
        getform.exitInterviewPolicyDocuments = this.documentValues[8];
      }
      // new 1st question
      if (this.documentValues[9][0].documentFile != '') {
        getform.availabilityIncTeamdocuments = this.documentValues[9];
      }

      // Show the loader
      this.getdata.amizhthLoader('show');

      // Send the data to the server
      this.makeapi.method(this.saveApi, getform, 'post').subscribe((data) => {
        // Hide the loader
        this.getdata.amizhthLoader('hide');
        // Check if the data is saved successfully
        if (data.responseStatus == 'Success') {
          // If the data is saved successfully, show a success message and move to the next step
          this.notify.notifysuccess(data.responseMessage);
          this.step++;
          this.getDataApi();
        } else {
          // If the data is not saved successfully, show an error message
          this.notify.notifyError(data.responseMessage);
        }
      });
    }
  }
  guidelinesBtn(data) {
    this.appCom.guidelinesModal(data);
  }
  guidelineValue: any = [];
  guidelineDatas() {
    this.http.get('/assets/json/guideline.json').subscribe((data) => {
      this.guidelineValue = data[3].questions;
    });
  }
  step = 0;
  setStep(index: number) {
    this.step = index;
  }
  nextStep() {
    this.saveBtn();
  }
  prevStep() {
    this.step--;
  }
}
